module.exports = __webpack_public_path__ + "static/media/glab-details-square.164a7ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/glab-details-square.png
// module id = 408
// module chunks = 0